import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SalesDocumentTemplateUpdateModal } from './SalesDocumentTemplateUpdateModal'

type SalesDocumentTemplateUpdateActivityProps = {
  refetchQuery: string
  salesDocumentTemplateId: string
}

export const SalesDocumentTemplateUpdateActivity: ActivityComponent<
  SalesDocumentTemplateUpdateActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <SalesDocumentTemplateUpdateModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      salesDocumentTemplateId={Number(data.salesDocumentTemplateId)}
    />
  )
}
